<template>
  <div>
    <v-select
      v-if="isInternacionalModuleActive"
      v-model="selectCountryLocal"
      class="col-30 mr-6 ml-0 input input-cpf allowed-countries"
      :items="allowedCountries"
      label="País"
      item-text="label"
      item-value="value"
      outlined
    >
      <template #item="{ item, attrs }">
        <v-list-item-content>
          <v-list-item-title class="country-select-item">
            <img class="flag" v-bind="attrs.icon" :src="require(`@/assets/${item.icon}`)" /> <span style="color: #4b525a">{{ item.label }}</span>
          </v-list-item-title>
        </v-list-item-content>
      </template>
      <template #selection="{ item, attrs }">
        <v-list-item-content>
          <v-list-item-title style="position: absolute; font-size: 25px">
            <img class="flag" v-bind="attrs.icon" :src="require(`@/assets/${item.icon}`)" />
          </v-list-item-title>
        </v-list-item-content>
      </template>
    </v-select>
    <div v-if="isBrazilSelectedCountry" class="d-flex" style="position: relative">
      <v-text-field
        :key="inputCep"
        v-mask="'#####-###'"
        v-validate="validator"
        outlined
        label="CEP"
        :value="value"
        :disabled="disabled"
        :loading="loading"
        :class="[(errors.first(field) || error) && 'block']"
        :append-icon="raw.length > 0 ? 'close' : ''"
        :error-messages="error !== '' ? error : errors.first(field)"
        :name="field"
        v-bind="config"
        @input="$emit('input', $event)"
        @click:append="clear"
      />
      <span class="url-cep">
        <a target="_blank" @click="openCep">Não sei meu CEP</a>
      </span>
    </div>
    <div v-else>
      <v-text-field
        :key="inputZipCode"
        outlined
        label="CEP"
        :value="value"
        :disabled="disabled"
        :class="[(errors.first(field) || error) && 'block']"
        :append-icon="raw.length > 0 ? 'close' : ''"
        :name="field"
        v-bind="config"
        @input="$emit('input', $event)"
        @click:append="clear"
      />
    </div>
  </div>
</template>

<script>
import { documentMaskMixin } from '@/mixins/document-mask'

export default {
  inject: ['$validator'],
  mixins: [documentMaskMixin],
  props: {
    value: String,
    field: String,
    selectedCountryLocal: String,
    config: Object,
    validator: Object,
    disabled: Boolean
  },
  data: () => ({
    loading: false,
    raw: '',
    selectCountryLocal: '',
    error: '',
    inputCep: 0,
    inputZipCode: 0
  }),
  computed: {
    isBrazilSelectedCountry() {
      return this.selectCountryLocal === 'BRASIL'
    }
  },
  watch: {
    value(value) {
      if (this.isBrazilSelectedCountry) {
        this.raw = value.length > 0 ? value.replace(/[^\d]+/g, '') : ''
        this.error = ''
        if (this.raw.length === 8) {
          this.getDataFromViaCep(this.raw)
        }
      }
    },
    selectCountryLocal(value) {
      this.$emit('set-country-local', value)
    },
    isBrazilSelectedCountry() {
      this.forceRerenderInputs()
    }
  },
  mounted() {
    this.selectCountryLocal = this.selectedCountryLocal
  },
  methods: {
    forceRerenderInputs() {
      this.inputCep += 1
      this.inputZipCode += 1
    },
    clear() {
      this.$emit('clear')
    },
    openCep() {
      window.open('https://buscacepinter.correios.com.br/app/endereco/index.php', '_blank')
    },
    async getDataFromViaCep(cep) {
      try {
        this.loading = true
        const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`, { method: 'GET' })
        const data = await response.json()
        if (data.erro) {
          this.$snackbar({
            message: 'CEP não encontrado',
            snackbarColor: 'error'
          })
          return
        } else {
          this.error = ''
        }
        this.$emit('via-cep-data', data)
      } catch (error) {
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss">
.url-cep {
  display: flex;
  justify-content: flex-end;
  position: absolute;
  right: 0px;
  top: -15px;
  a {
    font-family: 'Roboto', sans-serif;
    font-size: 11px;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
